import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { isIE } from './constants';
/** Returns true if focus is leaving `currentTarget`, to another element OR window. */

export function isFocusOut(event) {
  // IE sets activeElement before the blur/focus events, but doesn't support
  // relatedTarget. Note that in React 17 this might change if they switch
  // from focus/blur to focusin/focusout, which DO support relatedTarget.
  var focused = event.relatedTarget || (isIE ? document.activeElement : null);
  return !focused || !event.currentTarget.contains(focused);
}
/** Returns true if focus is moving to another element in the same window. */

export function isFocusLost(event) {
  // NOTE In Safari this behaves the same way as `isFocusOut`, because
  // it ALWAYS changes the `activeElement` when the window loses focus;
  // that means my old `requestAnimationFrame` workaround didn't work either,
  // so there isn't really anything we can do to get it to work in Safari.
  if (event.relatedTarget) {
    return !event.currentTarget.contains(event.relatedTarget);
  } else if (document.activeElement !== event.target) {
    return !event.currentTarget.contains(document.activeElement);
  } else {
    // This seems to work in all browsers, but IE has a caveat (of course):
    // if focus leaves the window this properly returns false, but when focus
    // returns to the window IE doesn't restore focus to the old activeElement,
    // so the activeElement changes without firing a blur event and whatever
    // behavior is controlled by `isFocusLost` won't fire.
    return false;
  }
}
export var CactusEventTarget = /*#__PURE__*/function () {
  function CactusEventTarget(props) {
    _classCallCheck(this, CactusEventTarget);

    this.id = void 0;
    this.name = void 0;
    this.value = void 0;
    this.id = props.id;
    this.name = props.name;
    this.value = props.value !== undefined ? props.value : null;
  } // I considered implementing this, but it doesn't seem worth the added complexity;
  // I might rethink that if React ever makes a way to bubble custom events.


  _createClass(CactusEventTarget, [{
    key: "addEventListener",
    value: function addEventListener() {
      throw new Error('Not Implemented');
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener() {
      throw new Error('Not Implemented');
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent() {
      throw new Error('Not Implemented');
    }
  }]);

  return CactusEventTarget;
}();

var BaseEvent = /*#__PURE__*/function () {
  function BaseEvent(type, target, originalEvent) {
    _classCallCheck(this, BaseEvent);

    this.reactEvent = void 0;
    this.currentTarget = void 0;
    this.target = void 0;
    this.bubbles = false;
    this.cancelable = false;
    this.type = void 0;
    this.type = type;
    this.currentTarget = this.target = target;
    this.reactEvent = originalEvent;
  }

  _createClass(BaseEvent, [{
    key: "nativeEvent",
    get: function get() {
      return this.reactEvent.nativeEvent;
    }
  }, {
    key: "eventPhase",
    get: function get() {
      return this.reactEvent.eventPhase;
    }
  }, {
    key: "isTrusted",
    get: function get() {
      return this.reactEvent.isTrusted;
    }
  }, {
    key: "timeStamp",
    get: function get() {
      return this.reactEvent.timeStamp;
    }
  }, {
    key: "defaultPrevented",
    get: function get() {
      return this.reactEvent.defaultPrevented;
    }
  }, {
    key: "preventDefault",
    value: function preventDefault() {
      this.reactEvent.preventDefault();
    }
  }, {
    key: "isDefaultPrevented",
    value: function isDefaultPrevented() {
      return this.reactEvent.isDefaultPrevented();
    }
  }, {
    key: "stopPropagation",
    value: function stopPropagation() {
      return this.reactEvent.stopPropagation();
    }
  }, {
    key: "isPropagationStopped",
    value: function isPropagationStopped() {
      return this.reactEvent.isPropagationStopped();
    }
  }, {
    key: "persist",
    value: function persist() {
      this.reactEvent.persist();
    }
  }]);

  return BaseEvent;
}();
/** This is compatible with `React.ChangeEvent` and `React.FormEvent`. */


export var CactusChangeEvent = /*#__PURE__*/function (_BaseEvent) {
  _inherits(CactusChangeEvent, _BaseEvent);

  var _super = _createSuper(CactusChangeEvent);

  function CactusChangeEvent(target, originalEvent) {
    _classCallCheck(this, CactusChangeEvent);

    return _super.call(this, 'change', target, originalEvent);
  }

  return _createClass(CactusChangeEvent);
}(BaseEvent);
/** This is compatible with `React.FocusEvent<any>`. */

export var CactusFocusEvent = /*#__PURE__*/function (_BaseEvent2) {
  _inherits(CactusFocusEvent, _BaseEvent2);

  var _super2 = _createSuper(CactusFocusEvent);

  function CactusFocusEvent(type, target, originalEvent) {
    var _this;

    _classCallCheck(this, CactusFocusEvent);

    _this = _super2.call(this, type, target, originalEvent);
    _this.relatedTarget = void 0;
    _this.relatedTarget = originalEvent.relatedTarget;
    return _this;
  }

  return _createClass(CactusFocusEvent);
}(BaseEvent);